import React, {type ReactNode, useCallback, useEffect} from "react";

interface ConfirmationDialogProps {
    isOpen: boolean;
    onClose: () => void;
    content: ReactNode;
    cancelButton: ReactNode;
    submitButton: ReactNode;
}

export function ConfirmationDialog({ isOpen, onClose, content, cancelButton, submitButton }: ConfirmationDialogProps) {

    const handleKeyDown = useCallback((e: KeyboardEvent) => {
        if (e.key === "Escape") {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        if (!isOpen) return;
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown, isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
            <div
                className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg p-6 max-w-sm w-full mx-4"
                onClick={(e) => e.stopPropagation()}
            >
                {content}
                <div className="flex justify-end gap-3">
                    {cancelButton}
                    {submitButton}
                </div>
            </div>
        </div>
    );
}

